/* SquishNest — theme.js */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount_with_comma_separator}} €';
    function withDelimiters(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var endAttr = (el.dataset.end || '').trim();
      var fixedEnd = endAttr ? new Date(endAttr + 'T23:59:59') : null;
      if (fixedEnd && isNaN(fixedEnd)) fixedEnd = null;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var now = new Date();
        var end = fixedEnd;
        if (!end || end <= now) {
          end = new Date(now); end.setHours(23, 59, 59, 999);
        }
        var diff = Math.max(0, Math.floor((end - now) / 1000));
        var hours = Math.floor(diff / 3600);
        h.textContent = pad(hours);
        m.textContent = pad(Math.floor((diff % 3600) / 60));
        s.textContent = pad(diff % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var nav = document.querySelector('[data-menu]');
    if (!nav) return;
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        document.querySelectorAll('.site-header__burger').forEach(function (b) { b.setAttribute('aria-expanded', open); });
      });
    });
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var mainImg = root.querySelector('.gallery__img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.gallery__thumb'));
    var thumbsWrap = root.querySelector('[data-thumbs]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var stickyBtn = document.querySelector('[data-sticky-btn]');

    function showThumb(t) {
      if (!t || !mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = t.dataset.src;
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      if (thumbsWrap) thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.offsetLeft - 8, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
    function step(dir) {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      showThumb(thumbs[(i + dir + thumbs.length) % thumbs.length]);
    }
    var prev = root.querySelector('[data-thumb-prev]'), next = root.querySelector('[data-thumb-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function update(variant) {
      if (!variant) return;
      var label;
      if (variant.available) {
        label = data.buttonLabel + ' · ' + formatMoney(variant.price, data.moneyFormat);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          label += ' <s>' + formatMoney(variant.compare_at_price, data.moneyFormat) + '</s>';
        }
        atc.disabled = false;
      } else {
        label = 'Épuisé';
        atc.disabled = true;
      }
      atcLabel.innerHTML = label;
      if (stickyBtn) { stickyBtn.innerHTML = label; stickyBtn.disabled = !variant.available; }
      if (variant.featured_media) {
        var t = thumbs.find(function (x) { return x.dataset.mediaId == variant.featured_media.id; });
        if (t) showThumb(t);
      }
      var url = new URL(window.location.href);
      if (url.pathname.indexOf('/products/') !== -1) {
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var v = data.variants.find(function (x) { return String(x.id) === input.value; });
        update(v);
      });
    });
    var checked = root.querySelector('[data-variant-input]:checked');
    if (checked) update(data.variants.find(function (x) { return String(x.id) === checked.value; }));

    /* Sticky add to cart */
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }
  }

  /* ---------- Reviews slider ---------- */
  function initSlider(root) {
    var track = root.querySelector('[data-track]');
    var dotsWrap = root.querySelector('[data-dots]');
    if (!track) return;
    var cards = track.children;
    function perView() {
      if (!cards.length) return 1;
      return Math.max(1, Math.round(track.clientWidth / cards[0].getBoundingClientRect().width));
    }
    function pages() { return Math.max(1, Math.ceil(cards.length / perView())); }
    function current() {
      var w = cards[0] ? cards[0].getBoundingClientRect().width + 18 : 1;
      return Math.round(track.scrollLeft / (w * perView()));
    }
    function go(p) {
      var w = cards[0].getBoundingClientRect().width + 18;
      track.scrollTo({ left: p * w * perView(), behavior: 'smooth' });
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Aller à la page ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { go(idx); }); })(i);
        dotsWrap.appendChild(b);
      }
      syncDots();
    }
    function syncDots() {
      if (!dotsWrap) return;
      var c = current();
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === c); });
    }
    var prev = root.querySelector('[data-slide-prev]'), next = root.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { var c = current(); go(c + 1 >= pages() ? 0 : c + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
  }

  function init() {
    initCountdown();
    initMenu();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
